import { Thermometer, Droplets, Ruler, Plug, Zap, Camera, CheckCircle2 } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const scope = [
  "Walls, ceilings, floors, paint, plaster and general finishing",
  "Tiles, grout and sealant in wet areas",
  "Doors, windows, glazing, frames, handles and locks",
  "Joinery, cabinetry, wardrobes and built-in storage",
  "Functional water flow and pressure observations where safe access and operating conditions allow",
  "Air-conditioning: operational, temperature and airflow observations within the agreed inspection scope",
  "Accessible switches, sockets, light fittings and distribution-board labels",
  "Balconies, terraces and external areas where lawful, safe and included in the agreed scope",
];

const equip = [
  [Thermometer, "Thermal imaging camera", "Where included in the agreed scope, may reveal observable temperature anomalies; it does not see through finishes or confirm concealed defects."],
  [Droplets, "Moisture meter", "Readings or indications of possible moisture — they do not prove the source or extent of concealed moisture."],
  [Ruler, "Laser level", "Alignment, levelling and finish checks."],
  [Plug, "Socket tester", "Limited functional indications of accessible points — not an electrical installation certification."],
  [Zap, "Infrared thermometer", "Spot surface-temperature readings."],
  [Camera, "Inspection camera", "Used only where safe access and the agreed scope permit."],
];

export default function WhatWeInspect() {
  return (
    <section id="what-we-inspect" className="py-20 lg:py-24 bg-white" data-testid="what-we-inspect">
      <div className="wrap">
        <SectionHead eyebrow="What we inspect" title="A systematic, room-by-room visual inspection."
          sub="We inspect the safe, accessible and observable areas included in the agreed scope. The inspection is visual and non-destructive; limitations are noted in the report." />
        <div className="grid lg:grid-cols-[1.05fr_.95fr] gap-12 items-start">
          <ul className="space-y-3">
            {scope.map((it) => (
              <li key={it} className="flex gap-2.5 text-bodytext">
                <CheckCircle2 size={19} className="text-blue flex-none mt-0.5" aria-hidden="true" /> {it}
              </li>
            ))}
          </ul>
          <div className="grid grid-cols-2 gap-3">
            {equip.map(([Icon, t, d], i) => (
              <Reveal key={t} delay={(i % 2) * 0.05}>
                <div className="bg-white border border-line rounded-xl p-5 h-full hover:shadow-sm hover:border-[#cfd8e6] transition-all">
                  <Icon size={22} className="text-blue mb-2.5" />
                  <h3 className="text-[0.94rem] font-semibold mb-1">{t}</h3>
                  <p className="text-[0.79rem] text-muted">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
